import { Component } from "react";
import Loader from "../../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import ExhibitorHeader from "../../../../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../../../../common_components/exhibitor_module_drawer";
import ExhibitorTopMenu from "../../../../../common_components/exhibitor_module_topmenu";
import { withRouter } from "../../../../../utils/withRouter";
import { connect } from "react-redux";
import { formatAmount, toastError, toastSuccess } from "../../../../../utils/constants";
import {
  getWaterDetails_action,
  insertUpdateWater_action,
} from "../../../../../actions/exhibitor_module_actions/manual_Forms_actions/forms_actions/water_form_action/water_form_action";
import { waterChargesActionId } from "../../../../../utils/constants";
import Modal from "react-modal";
import { data } from "jquery";
import { fill_action } from "../../../../../actions/fillCombo_action";
import HeaderWithLogo from "../../../../../common_components/header_with_logo";
import AdminDrawer from "../../../../../common_components/admin_module_drawer";
import moment from "moment";
import VendorDrawer from "../../../../../common_components/vendor_module_drawer";
import ConfirmationModal from "../../../../../common_components/confirmationa_modal";
import VendorDetails from "../../vendorDetails";

//
class Water extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      confirmationObj: { message: '', buttonName: '', action: '' },
      popArg: [],
      isOpenConfirmationModal: false,
      inletConnection: "",
      Quantity: "",
      outletConnection: "",
      PowerConnectionList: [],
      descriptionOfServiceList: [],
      Is_Agree: false,
      Remark: "",
      CGST: 0,
      SGST: 0,
      IGST: 0,
      Is_AgreeErr: "",
      DeadlineDate: "",
      currentDate: moment().format("DD-MM-YYYY"),
      inletChargesINR: "",
      outletChargesINR: "",
      inletChargesUSD: "",
      outletChargesUSD: "",
      is_View: false,
      totalAmount: 0,
      CGST: 0,
      SGST: 0,
      StatusID: "",
      CurrencyName: "",
      renderDeadline: "",
      RoleID: sessionStorage.getItem("RoleIDSS"),
      CurrencyID: JSON.parse(sessionStorage.getItem("ApplicationDataSS"))?.CurrencyID,
      isHideSection: sessionStorage.getItem("RoleIDSS") != 1 && sessionStorage.getItem("RoleIDSS") != 8,
      IsIGST: false
    };
    this.getWaterDetails = this.getWaterDetails.bind(this);
    this.submitWaterConnection = this.submitWaterConnection.bind(this);
    this.getFillList = this.getFillList.bind(this);
    this.preventMinus = this.preventMinus.bind(this);

    this.handleConfirmation = this.handleConfirmation.bind(this)
  }


  handleConfirmation(flag) {
    const { confirmationObj, popArg } = this.state;
    if (flag) {
      if (confirmationObj.action == 0) {
        this.submitWaterConnection()
      }
    }
    this.setState({ isOpenConfirmationModal: false })
  }

  // Get Fill Lists
  getFillList(actionID, exhibitionID, moduleID, keyValue, value, from) {
    const { } = this.state;
    this.setState({ isLoading: true });
    this.props
      .fill_action(actionID, exhibitionID, moduleID, keyValue, value)
      .then((data) => {
        if (data.error != 1) {
          // country list
          if (actionID === waterChargesActionId) {
            console.log("country data", data.data);
            for (var i = 0; i < data.data.length; i++) {
              if (data.data[i].NAME == "Inlet connection") {
                this.setState({ inletChargesINR: data.data[i].PriceINR });
                this.setState({ inletChargesUSD: data.data[i].PriceUSD });
              }
              if (data.data[i].NAME == "outlet connection") {
                this.setState({ outletChargesINR: data.data[i].PriceINR });
                this.setState({ outletChargesUSD: data.data[i].PriceUSD });
              }
            }
            // this.setState({ manualFormsList: data.data, isLoading: false })
          }
        } else {
          this.setState({ isLoading: false });
          toastError(data.msg);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  componentDidMount() {
    this.getFillList(waterChargesActionId, "", "", "", "", "");

    this.setState({
      DeadlineDate:
        this.props.location.state != null &&
          this.props.location.state != "" &&
          this.props.location.state.Deadline != ""
          ? moment(this.props.location.state.Deadline).format("DD-MM-YYYY")
          : "",
      is_View:
        this.props.location.state != null &&
          this.props.location.state != "" &&
          this.props.location.state.is_View != null
          ? this.props.location.state.is_View
          : sessionStorage.getItem("RoleIDSS") != 1,
      StatusID:
        this.props.location.state != null &&
          this.props.location.state != "" &&
          this.props.location.state.StatusID != null
          ? this.props.location.state.StatusID
          : false,
    });
    // this.getPowerConnectionList()
    this.getWaterDetails();

    console.log("jj", this.props);
  }

  getWaterDetails() {
    this.setState({ isLoading: true });
    this.props
      .getWaterDetails_action()
      .then((data) => {
        console.log(
          "data.data[0]['Is_Agree']",
          parseInt(sessionStorage.getItem("ExhRegistrationIDSS"))
        );
        if (data.error != 1) {
          if (data.data3 != "") {
            const array = [];
            data.data.map((item) => {
              for (let i = 0; i < data.data3.length; i++) {
                if (item.connection == data.data3[i]["connection"]) {
                  array.push(data.data3[i]);
                } else {
                  if (data.data3.length == 1) {
                    array.push({
                      connection: item["connection"],
                      Amount: 0,
                      Quantity: "",
                      Rates: item["Rates"],
                      ServiceID: item["ServiceID"],
                    });
                  }
                }
              }
            });
            this.setState({
              descriptionOfServiceList: array,
              CGST: data.data[0]["CGST"] * 100,
              SGST: data.data[0]["SGST"] * 100,
              IGST: data.data[0]["IGST"] * 100,
            });
          } else {
            data.data.map((item) => {
              item.Amount = 0;
              item.Quantity = "";
            });
            this.setState({
              descriptionOfServiceList: data.data,
              CGST: data.data[0]["CGST"] * 100,
              CGST: data.data[0]["CGST"] * 100,
              IGST: data.data[0]["IGST"] * 100,
            });
          }
          if (data.data2 != "") {
            this.setState({
              Quantity: data.data2[0]["Quantity"],
              Is_Agree: data.data2[0]["Is_Agree"],
              Remark: data.data2[0]["Remark"],
            });
          }

          this.setState({
            isLoading: false,
            IsIGST: data.IGST[0]['IsIGST'],
            CurrencyName: data.data[0]["CurrencyName"],
            renderDeadline:
              data.Deadline[0]["Deadline"] != null
                ? moment(data.Deadline[0]["Deadline"]).format("DD-MM-YYYY")
                : "",
          });
        } else {
          this.setState({ isLoading: false });
          toastError(data.msg);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  submitWaterConnection() {
    const {
      descriptionOfServiceList,
      Remark,
      Is_Agree,
      Quantity,
      inletConnection,
      outletConnection,
    } = this.state;
    // const { totalAmount } = this.calculateTotals

    const newArray = [];

    this.inputValidate();
    this.setState({ isLoading: true });
    const flag = descriptionOfServiceList.every(
      (item) => item.Quantity == "" || item.Quantity == 0
    );

    const ManualFormsID = this.props.location.state?.ManualFormsID || null;
    const ServiceID2 = this.props.location.state?.ServiceID || null;
    const VendorDetails = this.props.location.state?.VendorDetails || {};
    if (Is_Agree) {
      if (!flag) {
        this.props
          .insertUpdateWater_action(
            Quantity,
            descriptionOfServiceList[0]["Quantity"],
            descriptionOfServiceList[1]["Quantity"],
            Remark,
            Is_Agree == true ? 1 : 0,
            newArray,
            ManualFormsID,
            ServiceID2,
            VendorDetails
          )
          .then((data) => {
            if (data.error != 1) {
              this.setState({ isLoading: false });
              toastSuccess(
                this.state.StatusID == 0
                  ? "Water Connection Form Submitted Successfully"
                  : "Water Connection Form Updated Successfully"
              );
              setTimeout(() => {
                this.props.navigate("/manualForms");
              }, 2000);
            } else {
              this.setState({ isLoading: false });
              toastError(data.msg);
            }
          })
          .catch((e) => {
            console.log(e);
          });
      } else {
        this.setState({ isLoading: false });
        toastError("Please enter quantity");
      }
    } else {
      this.setState({ isLoading: false });
      toastError("kindly agree the terms and conditions");
    }
  }

  handleCancel() {
    if (this.state.RoleID != 1) {
      const CompanyName =
        this.props.location.state != null && this.props.location.state.companyName
          ? this.props.location.state.companyName
          : "";
      // this.props.navigate('/waterConnectionApproval', { state: { companyName: CompanyName } })

      const from =
        this.props.location.state != null && this.props.location.state.from != null
          ? this.props.location.state.from
          : "";
      if (from == "vendor") {
        this.props.navigate("/VendorModule", {
          state: { companyName: CompanyName },
        });
      } else {
        this.props.navigate("/waterConnectionApproval", {
          state: { companyName: CompanyName },
        });
      }
    } else {
      window.history.back();
    }
  }

  inputValidate() {
    const { Is_Agree } = this.state;

    if (Is_Agree == 0 || Is_Agree == false) {
      this.setState({ Is_AgreeErr: "kindly agree the terms and condition" });
    }
  }

  preventMinus = (e) => {
    console.log(e.code);
    if (e.code === "Minus") {
      e.preventDefault();
    }
  };

  enterQuantity(e, index) {
    const { descriptionOfServiceList } = this.state;
    const list = [...descriptionOfServiceList];
    const event = e.target.value.replace(/\D/, "");
    for (let i = 0; i < list.length; i++) {
      if (i == index) {
        list[i]["Quantity"] = event;
        if (event != "" && event != 0) {
          list[i]["Amount"] = event * list[i]["Rates"];
        } else {
          list[i]["Amount"] = 0;
        }
      }
    }
    this.setState({
      descriptionOfServiceList: list,
    });
  }

  calculateTotals() {
    try {
      const { descriptionOfServiceList } = this.state;
      let totalAmount = 0;
      descriptionOfServiceList.forEach((data) => {
        totalAmount += Number(data.Amount);
      });
      return {
        totalAmount,
      };
    } catch (e) {
      console.log("exception : ", e);
    }
  }

  render() {
    const {
      isLoading,
      Is_Agree,
      Remark,
      Quantity,
      inletChargesINR,
      outletChargesINR,
      inletChargesUSD,
      outletChargesUSD,
      descriptionOfServiceList,
      SGST,
      CGST,
      Is_AgreeErr,
      currentDate,
      DeadlineDate,
      is_View,
      StatusID,
      IGST,
      CurrencyName,
      renderDeadline,
      RoleID,
      CurrencyID,
      isHideSection, isOpenConfirmationModal,
      IsIGST
    } = this.state;

    const { totalAmount } = this.calculateTotals();
    const isDeadlinePassed =
      DeadlineDate &&
      moment(DeadlineDate, "DD-MM-YYYY") &&
      moment(currentDate, "DD-MM-YYYY").isAfter(moment(DeadlineDate, "DD-MM-YYYY"));
    return (
      <>
        {isOpenConfirmationModal ? <ConfirmationModal onConfirmation={this.handleConfirmation} message={this.state.confirmationObj} /> : null}
        {isLoading ? <Loader></Loader> : null}
        <ToastContainer />
        {!isHideSection && (
          <>
            {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 1 ||
              JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 8 ? (
              <ExhibitorHeader />
            ) : (
              <HeaderWithLogo />
            )}
            {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 1 ||
              JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 8 ? (
              <ExhibitorDrawer />
            ) : JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 7 ? (
              <VendorDrawer />
            ) : (
              <AdminDrawer />
            )}
          </>
        )}
        <div
          className={!isHideSection ? "with-dr-container" : ""}
          style={{ marginTop: RoleID == 1 ? "0px" : "" }}
        >
          <div className="main-container">
            {!isHideSection && (
              <div className="row mt-4">
                {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 1 ||
                  JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 8 ? (
                  <ExhibitorTopMenu />
                ) : null}
              </div>
            )}

            <div className="p-2 pt-0">
              <div class="card rounded-1 border mt-7 p-0">
                <div class="card-header">
                  <h3 class="card-title">
                    Water Connection Application
                  </h3>
                </div>
                <div class="card-body p-1 m-2" style={{ textAlign: "left" }}>
                  {!isHideSection && (
                    <>
                      <ol>
                        <li>
                          Exhibitors who require water for demonstration of their exhibits may also
                          note that due to stringent norms of effluent disposal, any type of
                          wastewater/effluent would not be allowed to be disposed off from the
                          stalls. Hence, kindly intimate Organizer’s office your requirement
                          regarding water usage, quantity and disposal considering the above fact
                        </li>
                        <li>
                          The facility will be provided subject to the conformation from official
                          conservancy agency appointed by INDIA ITME Society at an additional cost
                          if facility is provided. Exhibitor's should inform their water
                          connection/s requirements along with the payments{" "}
                          <strong className="text-aqua">before {renderDeadline}</strong>{" "}
                        </li>
                        <li>
                          If details of requirements along with the payment from Exhibitors,
                          received by INDIA ITME Society after{" "}
                          <strong>
                            {" "}
                            deadline {renderDeadline}, then additional surcharge of 25% of basic
                            rates shall be applicable to the Exhibitors.
                          </strong>
                        </li>
                      </ol>

                      <p>The tariff for water connection will be as under:-</p>
                    </>
                  )}
                  {!isHideSection && CurrencyID == 1 ? (
                    <p>
                      {" "}
                      1) For Indian exhibitors
                      <br />o <strong>Rs {descriptionOfServiceList?.[0]?.['Rates']}/-</strong> per inlet connection
                      <br />o <strong>Rs {descriptionOfServiceList?.[1]?.['Rates']}/-</strong> per outlet (drainage)
                      connection
                    </p>
                  ) : (
                    !isHideSection && (
                      <p>
                        2) For Foreign exhibitors
                        <br />o <strong>US Dollar {descriptionOfServiceList?.[0]?.['Rates']}/-</strong> per inlet connection
                        <br />o <strong>US Dollar {descriptionOfServiceList?.[1]?.['Rates']}/-</strong> per outlet
                        (drainage) connection
                      </p>
                    )
                  )}
                  {!isHideSection && (
                    <>
                      <p>
                        Plus GST @ 18% (as per Government rule) or as applicable is payable with all
                        the payments will not be refunded..
                      </p>
                      <p>
                        For drainage purpose we will provide tank with pump & 3/4"dia. pipe for the
                        drain purpose inside stall The sink and dish washing waste water will be
                        collect in one tank given capacity 175 Litre (size L = 36"; W = 18"; H =
                        18") Size of tank in meter L = 0.90; W = 0.45; H = 0.45
                      </p>
                      {/* <p>
                        <strong>
                          For more details or any queries please contact: itme@itme-africa.com
                        </strong>{" "}
                      </p> */}
                    </>
                  )}
                  <VendorDetails />
                  {!isHideSection && (
                    <div className="row mt-4">
                      <h6 className="mt-2 ">
                        Water Connection{" "}
                        <span className="text-danger">
                          {" "}
                          Last Date Of Submission -{" "}
                          {this.props.location?.state?.ActualDeadline
                            ? moment(this.props.location.state.ActualDeadline).format("DD-MM-YYYY")
                            : "-"}
                        </span>
                      </h6>
                    </div>
                  )}

                  <div class="table-responsive">
                    <table class="table border text-nowrap text-md-nowrap table-bordered mb-0 mt-1">
                      <thead>
                        <tr>
                          <th>
                            <strong>Description of Service</strong>
                          </th>
                          <th className="text-center">
                            <strong>Quantity</strong>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="col-xl-9">Consumption of water in litres /Hr</td>
                          <td>
                            <input
                              type="number"
                              class="form-control"
                              value={Quantity}
                              style={{ textAlign: 'right' }}
                              disabled={is_View || isDeadlinePassed || StatusID == 2}
                              onKeyUp={(e) => this.preventMinus(e)}
                              onChange={(e) => this.setState({ Quantity: e.target.value })}
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="table-responsive mt-3">
                    <table class="table border text-nowrap text-md-nowrap table-bordered mb-0 mt-1">
                      <thead>
                        <tr>
                          <th style={{ width: "55%" }}>
                            <strong>Description of Service</strong>
                          </th>
                          {!isHideSection && (
                            <th style={{ width: "15%" }} className="text-center">
                              <strong>Rates ({CurrencyName})</strong>
                            </th>
                          )}
                          <th style={{ width: "15%" }} className="text-center">
                            <strong>Quantity</strong>
                          </th>
                          {!isHideSection && (
                            <th style={{ width: "15%" }} className="text-center">
                              <strong>Amount ({CurrencyName})</strong>
                            </th>
                          )}
                        </tr>
                      </thead>
                      <tbody>
                        {descriptionOfServiceList != "" ? (
                          descriptionOfServiceList.map((data, i) => (
                            <tr>
                              <td>{data.connection}</td>
                              {!isHideSection && (
                                <td style={{ textAlign: "right" }}>{formatAmount(data.Rates)}</td>
                              )}
                              <td class="text-right">
                                <input
                                  type="text"
                                  style={{ textAlign: 'right' }}
                                  class="form-control"
                                  value={data.Quantity}
                                  disabled={is_View || isDeadlinePassed || StatusID == 2}
                                  maxLength={8}
                                  onChange={(e) => this.enterQuantity(e, i)}
                                />
                              </td>
                              {!isHideSection && (
                                <td style={{ textAlign: "right" }}>{formatAmount(data.Amount)}</td>
                              )}
                            </tr>
                          ))
                        ) : (
                          <></>
                        )}
                        <tr>
                          <td colspan="2"></td>
                          {!isHideSection && (
                            <td>
                              <strong>Total</strong>
                            </td>
                          )}
                          {!isHideSection && (
                            <td style={{ textAlign: "right" }}>
                              <strong>{formatAmount(totalAmount)}</strong>
                            </td>
                          )}
                        </tr>
                        {!IsIGST ? (
                          <>
                            {!isHideSection &&
                              <>
                                <tr>
                                  <td colspan="2"></td>
                                  <td>
                                    <strong>CGST @ {CGST}%</strong>
                                  </td>
                                  <td style={{ textAlign: "right" }}>
                                    <strong>{formatAmount((CGST / 100) * totalAmount)}</strong>
                                  </td>
                                </tr>
                                <tr>
                                  <td colspan="2"></td>
                                  <td>
                                    <strong>SGST @ {SGST}%</strong>
                                  </td>
                                  <td style={{ textAlign: "right" }}>
                                    <strong>{formatAmount((SGST / 100) * totalAmount)}</strong>
                                  </td>
                                </tr>
                              </>
                            }
                          </>
                        ) : (
                          <>
                            {!isHideSection && (
                              <tr>
                                <td colspan="2"></td>
                                <td>
                                  <strong>IGST @ {IGST}%</strong>
                                </td>
                                <td style={{ textAlign: "right" }}>
                                  <strong>{formatAmount((IGST / 100) * totalAmount)}</strong>
                                </td>
                              </tr>
                            )}
                          </>
                        )}
                        {!isHideSection && (
                          <tr style={{ backgroundcolor: "#eee" }}>
                            <td colspan="2"></td>
                            <td>
                              <strong>Grand Total</strong>
                            </td>
                            <td style={{ textAlign: "right" }}>
                              <strong>
                                {formatAmount(
                                  (IGST / 100) * totalAmount +
                                  totalAmount
                                )}
                              </strong>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  {/* <button type="button" class="btn btn-primary rounded-0 m-2 mt-3"
                                            disabled={is_View} style={{ float: 'right' }} onClick={(e) => this.OnAddDescription(e)}>
                                            Add Description
                                        </button>
                                        <div class="table-responsive">
                                            <table class="table border text-nowrap text-md-nowrap table-bordered mb-0 mt-1">
                                                <thead>
                                                    <tr>
                                                        <th className="text-center"><strong>Description of Service</strong></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {descriptionOfServiceList.length > 0 && descriptionOfServiceList.map((data, i) => (
                                                        <tr key={data}>
                                                            <td>
                                                                <input type="text" class="form-control"
                                                                    value={data.Description}
                                                                    disabled={is_View}
                                                                    onChange={(e) => this.enterDescriptions(e, i)}
                                                                />
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div> */}
                </div>
                {!isHideSection && (
                  <div class="row m-1">
                    <form>
                      <label>Remark</label>
                      <textarea
                        class="form-control"
                        value={Remark}
                        disabled={is_View || isDeadlinePassed || StatusID == 2}
                        maxLength={"1000"}
                        onChange={(e) => this.setState({ Remark: e.target.value })}
                        rows="3"
                      ></textarea>
                      <label class="d-flex mt-1" style={{ lineheight: "15px;" }}>
                        <input
                          type="checkbox"
                          disabled={is_View || isDeadlinePassed || StatusID == 2}
                          checked={Is_Agree}
                          onChange={(e) => this.setState({ Is_Agree: true, Is_AgreeErr: "" })}
                        />
                        We hereby read &amp; understood the above mentioned clauses &amp;
                        consequences. We accept &amp; agree to abide by the same.
                      </label>
                      {
                        <span className="text-danger text-start text-left d-block mt-1">
                          {Is_AgreeErr}
                        </span>
                      }
                    </form>
                  </div>
                )}
              </div>
            </div>
            {!isHideSection && (
              <div className="row">
                {currentDate > DeadlineDate && (
                  <span className="text-danger">THE DEADLINE TO FILL OUT THE FORM HAS PASSED.</span>
                )}
              </div>
            )}
            {!isHideSection && (
              <div class="d-flex justify-content-end mt-0">
                {!is_View ? (
                  <button
                    type="button"
                    className="btn btn-aqua rounded-1 d-block mt-3 mb-3"
                    style={{ marginRight: 10 }}
                    disabled={isDeadlinePassed || StatusID == 2}
                    onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: `Do you want to  ${this.state.StatusID == 0 ? "Submit" : "Update"}?`, buttonName: this.state.StatusID == 0 ? "Submit" : "Update", action: 0 }, popArg: [] })}
                  // onClick={() => this.submitWaterConnection()}
                  >
                    {this.state.StatusID == 0 ? "Submit" : "Update"}
                  </button>
                ) : (
                  <></>
                )}
                <button
                  className="btn btn-gray rounded-1 d-block mt-3 mb-3"
                  onClick={() => this.handleCancel()}
                >
                  Back
                </button>
              </div>
            )}
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(
  connect(null, {
    getWaterDetails_action,
    insertUpdateWater_action,
    fill_action,
  })(Water)
);
